import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { MockKeycloakProvider } from './contexts/MockKeycloakProvider'
import { store } from './store'
import App from './App'
import './styles/globals.css'
import i18n, { ensureLanguage } from './lib/i18n'
import { captureFirstTouch } from './lib/attribution'

// remember which campaign link brought this visitor (before any redirect drops the tags)
captureFirstTouch()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

// Strip Keycloak error fragments from the URL to prevent Router confusion
if (window.location.hash && window.location.hash.includes('error=login_required')) {
  window.history.replaceState(null, '', window.location.pathname + window.location.search)
}

const AppContent = () => (
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </Provider>
)

// Fetch the visitor's language bundle (if not English) before the first paint,
// so the UI never flashes English or raw keys.
ensureLanguage(i18n.language).finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <MockKeycloakProvider>
      <AppContent />
    </MockKeycloakProvider>
  )
})
